import React from 'react';
import { FC } from 'react';
import InfoLayout from 'layouts/info';
import Icon from 'components/icon';

interface LoadingProps {
  message?: string;
};

const LoadingPage: FC<LoadingProps> = ({ message = 'Loading...' }) => {
  return (
    <InfoLayout>
      <div className="text-center">
        <Icon name="loading" />
        <div className="mt-3 text-muted">
          {message}
        </div>
      </div>
    </InfoLayout>
  )
};

export default LoadingPage;